import React, {useState} from 'react';
import { downloadBaseIcon, editIcon, shareOIcon } from '../../../../constants/icons';
import ModalShare from '../modals/ModalShare';

const ActionBtnsTemplate = ({ value, data, tableManager }) => {
  
  const [isModalShareOpen, setIsModalShareOpen] = useState(false);
  const openModalShare = () => setIsModalShareOpen(true);
  const closeModalShare = () => setIsModalShareOpen(false);

  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = (
    'rgt-cell-inner rgt-text-truncate customize-column btn-grid-file btn btn-glitter btn-sm btn-round bg-white border-0 d-flex gap-2 align-items-center px-1' +
    (additionalProps.className || '')
  ).trim();

  const handleClick = (action) => {
    let ditem = {};
    ditem.itemId                        = data.id;
    ditem.itemType                      = data.i_item_type;
    ditem.parentId                      = data.i_parent_id;
    ditem.itemName                      = data.i_item_name;
    ditem.itemOriginalFilename          = data.i_original_filename;
    ditem.itemDocumentType              = data.i_document_type;
    ditem.itemDocumentTags              = data.i_document_tags;
    ditem.itemSectionType               = data.i_section_id;
    ditem.itemFolderShortDescription    = data.i_folder_short_desc;
    ditem.itemDownloadUrl               = data.download_url;
    if(action === "Share") {
      ditem.key = "2";
    }
    if(action === "Edit") {
      ditem.key = "1";
    }
    if(action === "Download") {
      ditem.key = "3"
    }
    data.handleDropdownClick(ditem);
  };

  return (
    <>
      {value && (
        <>
          {data.file_action && data.file_action.includes('Share') && (
            <button
              type="button"
              className={classNames}
              onClick={openModalShare}
            >
              {shareOIcon}
            </button>
          )}

          {data.file_action && data.file_action.includes('Edit') && (
            <button
              type="button"
              className={classNames}
              onClick={() => handleClick('Edit')}
            >
              {editIcon}
            </button>
          )}

          {data.file_action && data.file_action.includes('Download') && (
            <button
              type="button"
              className={classNames}
              onClick={() => handleClick('Download')}
            >
              {downloadBaseIcon}
            </button>
          )}
        </>
      )}
      <ModalShare 
        showModal={isModalShareOpen} 
        setShowModalShare={setIsModalShareOpen} 
        closeModal={closeModalShare}
      />
    </>
  );
};

export default ActionBtnsTemplate;
